import React, { useState } from "react";

import CoachReport from "@legacy/Reports/CoachReport";
import SelectReport from "@legacy/Reports/SelectReport";
import MedicalReport from "@legacy/Reports/MedicalReport";

export default function ClearscreenReport() {
  const [reportType, setReportType] = useState("coach");

  return (
    <div>
      {["coach", "select", "medical"].map((type) => (
        <button key={type} onClick={() => setReportType(type)}>
          {type}
        </button>
      ))}
      {reportType === "coach" && (
        <CoachReport
          data={{
            company: {
              name: "Company Name",
            },
            employee: {
              full_name: "Employee Name",
            },
            profile_name: "Profile Name",
            holland: "Holland",
            calculation_container: {
              lcl_likeness: "LCL Likeness",
              lcl_likeness_x: 1,
              lcl_likeness_y: 1,
              lcl_likeness_z: 1,
              x_axis: 1,
              y_axis: 1,
              z_axis: 1,
              occupational_profile_calculation_containers: [
                {
                  name: "Occupational Profile Name",
                  steq_score: 1,
                },
              ],
              derailers: [
                {
                  name: "Derailer Name",
                  triggered: true,
                },
              ],
            },
          }}
        />
      )}
      {reportType === "select" && (
        <SelectReport
          data={{
            company: {
              name: "Company Name",
            },
            employee: {
              full_name: "Employee Name",
            },
            profile_name: "Profile Name",
            holland: "Holland",
            calculation_container: {
              lcl_likeness: "LCL Likeness",
              lcl_likeness_x: 1,
              lcl_likeness_y: 1,
              lcl_likeness_z: 1,
              x_axis: 1,
              y_axis: 1,
              z_axis: 1,
              occupational_profile_calculation_containers: [
                {
                  name: "Occupational Profile Name",
                  steq_score: 1,
                },
              ],
              derailers: [
                {
                  name: "Derailer Name",
                  triggered: true,
                },
              ],
            },
          }}
        />
      )}
      {reportType === "medical" && (
        <MedicalReport
          data={{
            company: {
              name: "Company Name",
            },
            employee: {
              full_name: "Employee Name",
            },
            profile_name: "Profile Name",
            holland: "Holland",
            calculation_container: {
              lcl_likeness: "LCL Likeness",
              lcl_likeness_x: 1,
              lcl_likeness_y: 1,
              lcl_likeness_z: 1,
              x_axis: 1,
              y_axis: 1,
              z_axis: 1,
              occupational_profile_calculation_containers: [
                {
                  name: "Occupational Profile Name",
                  steq_score: 1,
                },
              ],
              derailers: [
                {
                  name: "Derailer Name",
                  triggered: true,
                },
              ],
            },
          }}
        />
      )}
    </div>
  );
}
